import {
  DownloadMaterialsSetGqlQuery,
  DownloadMaterialsSetGqlStatus,
  MaterialsSetDeviceNanoId,
  MaterialsSetGqlError,
  MaterialsSetUUID
} from '../../materialsSetsTypes';

import { useUpdateQuery } from '../../../common/reactQuery/hooks/useUpdateQuery';

interface DownloadMaterialsSetOptions {
  query: DownloadMaterialsSetGqlQuery;
  cacheKeys?: string[];
}

export interface DownloadMaterialsSetResponse<DownloadMaterialsSetRecordType> {
  downloadMaterialsSet: {
    status: DownloadMaterialsSetGqlStatus;
    recordUuid: MaterialsSetUUID;
    record: DownloadMaterialsSetRecordType;
    errors: DownloadMaterialsSetError;
  };
}

export interface DownloadMaterialsSetInput {
  uuid: MaterialsSetUUID;
  deviceNanoId: MaterialsSetDeviceNanoId;
}

export interface DownloadMaterialsSetError {
  fullMessages: MaterialsSetGqlError;
}

const action = 'downloadMaterialsSet';

function useDownloadMaterialsSet<DownloadMaterialsSetRecordType>({
  query,
  cacheKeys
}: DownloadMaterialsSetOptions) {
  const {
    updateQueryData,
    updateQuery,
    updateQueryReset,
    updateQueryError,
    updateQueryLoading,
    updateQueryErrorMessage
  } = useUpdateQuery<
    DownloadMaterialsSetInput,
    DownloadMaterialsSetResponse<DownloadMaterialsSetRecordType>,
    DownloadMaterialsSetError,
    DownloadMaterialsSetRecordType
  >({ action, query, cacheKeys });

  return {
    downloadMaterialsSetData: updateQueryData,
    downloadMaterialsSetError: updateQueryError,
    downloadMaterialsSetLoading: updateQueryLoading,
    downloadMaterialsSetErrorMessage: updateQueryErrorMessage,
    downloadMaterialsSet: updateQuery,
    downloadMaterialsSetReset: updateQueryReset
  };
}

export default useDownloadMaterialsSet;
